import { useEffect, useState } from "react";

export const useLocalStorage = (key: string): [string | null, (newValue: string | null) => void] => {
  const [value, setValue] = useState(() => localStorage.getItem(key));

  useEffect(() => {
    const handleStorageChange = () => {
      setValue(localStorage.getItem(key));
    };
    
    // Listen for cross-window storage changes (native browser event)
    window.addEventListener("storage", handleStorageChange);
    
    // Listen for same-window storage changes (custom event)
    window.addEventListener(`storage:${key}`, handleStorageChange);
    
    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener(`storage:${key}`, handleStorageChange);
    };
  }, [key]);
  const setLocalStorage = (newValue: string | null) => {
    const currentValue = localStorage.getItem(key);
    if (currentValue === newValue) {
      return;
    }
    if (!newValue) {
      localStorage.removeItem(key);
      setValue(null);
    } else {
      localStorage.setItem(key, newValue);
      setValue(newValue);
    }
    
    // Dispatch event to notify other useLocalStorage hooks in the same window
    window.dispatchEvent(new Event(`storage:${key}`));
  };
  return [value, setLocalStorage];
};
